export default import.meta.ROLLDOWN_FILE_URL_c7lJQ8caTm8Y7COGVvNbJg